<section class="sg-section w-full px-4 sm:px-8">
    <div class="sg-inner mx-auto flex w-full max-w-[1280px] flex-col items-center text-center">
        <h2 class="sg-heading font-outfit font-bold">
            end-to-end <span class="gradient-text">app growth</span> solutions
        </h2>

        <p class="sg-subhead font-inter mt-6">Building an app is only the beginning.</p>

        <p class="sg-prose font-inter mt-5">
            Many applications fail not because of poor products but because of weak distribution,
            ineffective marketing, or a lack of product-market fit. SEMNexus combines development,
            marketing, analytics, and growth strategy to help businesses build sustainable growth
            systems rather than isolated campaigns.
        </p>

        <p class="sg-prose font-inter mt-5">Our services include:</p>

        <ul class="sg-grid mt-12 grid w-full gap-5 grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
            @for (card of cards; track $index) {
                <li class="sg-card">
                    <a [routerLink]="card.link" class="sg-card-link" [attr.aria-label]="card.line1 + ' ' + card.line2">
                        <img class="sg-card-img" [src]="'images/landing/services-grid/' + card.image" alt=""
                            aria-hidden="true" loading="lazy" />
                        <span class="sg-card-overlay" aria-hidden="true"></span>
                        <span class="sg-card-label font-outfit font-bold">
                            <span class="sg-card-l1 gradient-text">{{ card.line1 }}</span>
                            <span class="sg-card-l2">{{ card.line2 }}</span>
                        </span>
                    </a>
                </li>
            }
        </ul>
    </div>
</section>
